const ACCESS_PAUSED_PATH_RE = /^\/\d+\/access-paused\/?$/;

/**
 * Returns the access-paused route path for the given org.
 */
export function getAccessPausedPath(orgId: number | string): string {
  return `/${orgId}/access-paused`;
}

/**
 * Returns true if pathname matches the access-paused route for any org.
 */
export function isAccessPausedPath(pathname: string): boolean {
  return ACCESS_PAUSED_PATH_RE.test(pathname);
}
